export const SERVICE_OPTIONS = [
  { value: "mowing-tidy", label: "Mowing & tidy", priceLabel: "$40 / hr" },
  { value: "exterior-wash", label: "Exterior wash", priceLabel: "$60" },
  { value: "interior-clean", label: "Interior clean", priceLabel: "$75" },
  { value: "full-inside-out", label: "Full inside & out", priceLabel: "$125" },
  { value: "other", label: "Something else / not sure", priceLabel: "" },
];

export function findService(value) {
  return SERVICE_OPTIONS.find((s) => s.value === value);
}
